export default __webpack_public_path__ + "static/media/ers-desktop.a06db917.png";